module.exports = __webpack_public_path__ + "static/media/RobotoMono-Regular.e5ca8c0a.ttf";